const API = {
  SITE_API_V1: "https://api.daapapp.com/api/v1/site/",
  PUBLIC_API_V1: "https://api.daapapp.com/api/v1/client/",
  PUBLIC_API_V2: "https://api.daapapp.com/api/v2/client/",

  BASE_URL_IMAGE: "https://images.daapapp.com/",
};

export default API;
